import React from 'react';
import Route from 'enum/route.enum';
import { Navigate } from 'react-router-dom';

import { translate as t } from 'utils/i18n';
import NewsContainer from 'components/news/NewsContainer';

import {
  Container,
  NewsOuterContentContainer,
  NewsContentContainer,
  NewsContentBody,
  NewsSectionHeading,
  NewsSourceList,
  NewsSourceItem,
} from './styles';
import HeaderBarComponent from './components/HeaderBar';
import { calculateDisplayedCategories } from 'utils/common/calculateDisplayedCategories';

import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';
import NewsDisplay from './components/NewsDisplay';

import PageHeader from './components/PageHeader';
import CachedImg from 'components/common/CachedImg/CachedImg';

class newsList extends NewsContainer {
  constructor(props) {
    super(props);
    this.backButtonRef = React.createRef();
  }

  componentDidMount() {
    super.componentDidMount();
  }

  render() {
    const { redirectBack, loading, showError, items, focusIndex, allowedItems } = this.state;
    let displayed = items;
    if (Storages.MainStorage.getItem(StorageKeys.Keys.ACTIVETEMPLATE)) {
      displayed = calculateDisplayedCategories(items, focusIndex, allowedItems);
    }

    if (redirectBack) {
      return <Navigate to={Route.route.LANDING} />;
    }

    return (
      <Container>
        <HeaderBarComponent></HeaderBarComponent>
        <NewsOuterContentContainer>
          <NewsContentContainer>
            <PageHeader
              title={t('News.news')}
              onBack={() => this.setState({ redirectBack: true })}
              ref={this.backButtonRef}
            ></PageHeader>
            <NewsContentBody>
              {items?.[focusIndex]?.latest_news && (
                <NewsSectionHeading>{items[focusIndex].latest_news}</NewsSectionHeading>
              )}
              {items.length <= 0 && !loading ? (
                <div className={`has-text-danger has-text-centered`}>
                  <p className={'is-size-4 has-text-bold'}>{t('News.newsError')}</p>
                </div>
              ) : items.length <= 0 && showError && loading ? (
                <div className={`has-text-danger has-text-centered`}>
                  <p className={'is-size-4 has-text-bold'}>
                    The selected language is not configured yet.
                  </p>
                </div>
              ) : (
                items.length > 0 && <NewsDisplay news={items[focusIndex]} backButtonRef={this.backButtonRef}></NewsDisplay>
              )}
            </NewsContentBody>
            <NewsSourceList>
              {displayed &&
                displayed.map((d) => (
                  <NewsSourceItem
                    key={d.locale_latest_news?.id || ''}
                    active={d.active}
                    onClick={() => this.clickHandler(null, d)}
                  >
                    {d.logo
                      ? <CachedImg
                          src={d.logo}
                          alt={d.latest_news || ''}
                        ></CachedImg>
                      : (d.latest_news || '')}
                  </NewsSourceItem>
                ))}
            </NewsSourceList>
          </NewsContentContainer>
        </NewsOuterContentContainer>
      </Container>
    );
  }
}

export default newsList;
